import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center",
    },
    rowText: {
        fontSize: 12,
        width: "60%",
    },
    xyz: {
        width: "40%",
    },
});

//TODO: more general table row. Currently designed for general abilties
const TableRow = ({ items } ) => {
    const rows = items.map((item) => (
        <View style={styles.row} key={item.id}>
            <Text style={styles.rowText}>{item.name}</Text>
            <Text style={styles.rowText}>{item.maxPoints}</Text>            
        </View>
    ));
    return <Fragment>{rows}</Fragment>;
};

export default TableRow;